import { render, staticRenderFns } from "./Sale-modal.vue?vue&type=template&id=c287508c"
import script from "./Sale-modal.vue?vue&type=script&lang=js"
export * from "./Sale-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports